import { CountryCode } from 'root-constants/common'

const COUNTRIES_WITHOUT_PAYPAL: string[] = [
  CountryCode.ARGENTINA,
  CountryCode.COLOMBIA,
  CountryCode.PERU,
  CountryCode.CHILE,
  CountryCode.DOMINICAN_REPUBLIC,
  CountryCode.URUGUAY,
  CountryCode.ECUADOR,
  CountryCode.GUATEMALA,
  CountryCode.VENEZUELA,
  CountryCode.PARAGUAY,
  CountryCode.BOLIVIA,
  CountryCode.NICARAGUA,
  CountryCode.HONDURAS,
  CountryCode.COSTA_RICA,
  CountryCode.PANAMA,
  CountryCode.EL_SALVADOR,
  CountryCode.MEXICO,
  CountryCode.PUERTO_RICO,
  CountryCode.BRAZIL,
  CountryCode.INDIA,
  CountryCode.PHILIPPINES,
  CountryCode.SOUTH_AFRICA,
  CountryCode.NIGERIA,
  CountryCode.KENYA,
  CountryCode.ZAMBIA,
  CountryCode.TANZANIA,
  CountryCode.ETHIOPIA,
  CountryCode.ZIMBABWE,
  CountryCode.SENEGAL,
  CountryCode.NAMIBIA,
  CountryCode.SAUDI_ARABIA,
  CountryCode.TURKEY,
  CountryCode.KUWAIT,
  CountryCode.IRAQ,
  CountryCode.UNITED_ARAB_EMIRATES,
  CountryCode.JORDAN,
  CountryCode.QATAR,
  CountryCode.LEBANON,
  CountryCode.OMAN,
  CountryCode.BAHRAIN,
  CountryCode.EGYPT,
  CountryCode.MOROCCO,
  CountryCode.ALGERIA,
  CountryCode.POLAND,
]

export const isPayPalAvailableByCountry = (countryCode: string): boolean =>
  !COUNTRIES_WITHOUT_PAYPAL.includes(countryCode.toLowerCase())
